export type DocumentScope = 'route' | 'stop' | 'cargo';

const ROUTE_LEVEL = new Set([
  'CARRIER_INVOICE',
  'LOADING_INVOICE',
  'UPD_ACT',
  'UPD',
  'REGISTRY',
  'CLOSING',
  'CLOSING_DOCS'
]);

const STOP_LEVEL = new Set([
  'LOADING_PHOTO',
  'LOADING_TN',
  'UNLOADING_PHOTO',
  'UNLOADING_DOC',
  'SIGNED_TN',
  'TN_ORIGINAL',
  'ORIGINAL_TN'
]);

export function resolveDocumentScope(documentType: string): DocumentScope {
  const t = String(documentType || '').trim().toUpperCase();
  if (ROUTE_LEVEL.has(t)) return 'route';
  if (STOP_LEVEL.has(t)) return 'stop';
  return 'cargo';
}

export const CARRIER_INVOICE_ROUTE_TASK_TYPES = [
  'CARRIER_INVOICE_MISSING',
  'INVOICE_EXPECTED',
  'CARRIER_INVOICE_CONFIRM'
] as const;
